/** 纯色mapbox底图样式（#a1dcff） */
export const SolidColorStyle: mapboxgl.Style = {
    "version": 8,
    "name": "SolidColor-copy",
    "metadata": {},
    "sources": {},
    "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
    "layers": [],
};

